// Shared between CardRequest.vue (which starts the SlickPay payment) and
// PaymentSuccess.vue (which finishes the card request once payment is
// confirmed). The id photo is round-tripped through localStorage as base64
// because the SATIM redirect leaves the SPA entirely, so a plain File object
// wouldn't survive the trip.

import TypeCarteService from "./TypeCarteService";

export const PENDING_CARD_REQUEST_KEY = "pendingCardRequest";

// Card type -> name as stored in the type-carte table, used both as the
// `name` query param for GET /type-carte/price and as the i18n label key.
export const CARD_TYPE_NAMES = {
  platinum: "Platinum card",
  gold: "Gold card",
  classic: "Classic card",
};

function extractPrice(payload) {
  if (payload == null) return undefined;
  if (typeof payload === "number") return payload;
  if (typeof payload === "string") return Number(payload);
  if (typeof payload.price !== "undefined") return Number(payload.price);
  if (payload.data) return extractPrice(payload.data);
  return undefined;
}

// Fetches the current fee (DA) for every card type from the backend
// (GET /type-carte/price?name=...) instead of relying on hardcoded values
// that can drift from what's actually configured server-side.
export async function fetchCardPrices() {
  const entries = await Promise.all(
    Object.entries(CARD_TYPE_NAMES).map(async ([type, name]) => {
      const { data } = await TypeCarteService.getPrice(name);
      return [type, extractPrice(data)];
    })
  );
  return Object.fromEntries(entries);
}

// SlickPay's contact endpoint requires a "rib" (20 numeric digits, unique
// per contact) even though it's meaningless for someone just paying a card
// fee - so a fresh one is generated per submission instead of asking the
// user for a real bank account number.
export function generateRib() {
  let rib = "";
  for (let i = 0; i < 20; i++) {
    rib += Math.floor(Math.random() * 10);
  }
  return rib;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function base64ToFile(base64, filename) {
  const [header, data] = base64.split(",");
  const mimeMatch = /:(.*?);/.exec(header);
  const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], filename, { type: mime });
}
